__turbopack_context__.v({
  "trigger": "I7MCQW_trigger",
  "wrapper": "I7MCQW_wrapper",
});
